export default "__VITE_ASSET__DYUcpvJp__"